import moment from "moment";

export function inicialNome(nome) {
  const texto = (nome || "?").trim();
  return texto.charAt(0).toUpperCase();
}

export function formatarHoraChat(data) {
  if (!data) return "";
  const momento = moment(data);
  if (!momento.isValid()) return "";
  if (momento.isSame(moment(), "day")) {
    return momento.format("HH:mm");
  }
  if (momento.isSame(moment().subtract(1, "day"), "day")) {
    return "ontem";
  }
  return momento.format("DD/MM");
}

export function somaNaoLidas(conversas) {
  return (conversas || []).reduce(
    (total, item) => total + (Number(item?.naoLidas) || 0),
    0
  );
}

export function mesclarConversa(lista, conversa) {
  if (!conversa?.codigo) return lista || [];
  const atual = (lista || []).find(
    (item) => String(item.codigo) === String(conversa.codigo)
  );
  const mesclada = {
    ...conversa,
    fixada: conversa.fixada ?? atual?.fixada,
  };
  const restante = (lista || []).filter(
    (item) => String(item.codigo) !== String(conversa.codigo)
  );
  return ordenarConversasLista([mesclada, ...restante]);
}

export function ordenarConversasLista(lista) {
  const pinadas = [];
  const outras = [];
  (lista || []).forEach((item) => {
    if (item?.fixada) {
      pinadas.push(item);
    } else {
      outras.push(item);
    }
  });
  return [...pinadas, ...outras];
}

export function mesclarMensagem(lista, mensagem) {
  if (!mensagem?.codigo) return lista || [];
  if ((lista || []).some((item) => String(item.codigo) === String(mensagem.codigo))) {
    return lista;
  }
  return [...(lista || []), mensagem];
}

export function conversaEstaAtiva(aberto, vista, conversaAtualCodigo, codigoRecebido) {
  return Boolean(
    aberto &&
      vista === "thread" &&
      conversaAtualCodigo &&
      codigoRecebido &&
      String(conversaAtualCodigo) === String(codigoRecebido)
  );
}

export function deveSinalizarNovaMensagem(conversaAtiva, autorCodigo, codigoUsuario) {
  if (conversaAtiva) {
    return false;
  }
  if (!autorCodigo || String(autorCodigo) === String(codigoUsuario || "")) {
    return false;
  }
  return true;
}

export function conversaAposEvento(conversa, conversaAtiva) {
  if (!conversa) {
    return conversa;
  }
  if (!conversaAtiva) {
    return conversa;
  }
  return { ...conversa, naoLidas: 0 };
}

export function codigoConversaDoEvento(evento) {
  return evento?.mensagem?.conversaCodigo || evento?.conversa?.codigo || null;
}

export function mesclarFixada(lista, mensagem) {
  if (!mensagem?.codigo) return lista || [];
  const restante = (lista || []).filter(
    (item) => String(item.codigo) !== String(mensagem.codigo)
  );
  return [...restante, { ...mensagem, fixada: true }].slice(0, 3);
}

export function removerFixada(lista, mensagem) {
  if (!mensagem?.codigo) return lista || [];
  return (lista || []).filter(
    (item) => String(item.codigo) !== String(mensagem.codigo)
  );
}

export function marcarMensagemFixada(lista, codigo, fixada) {
  return (lista || []).map((item) =>
    String(item.codigo) === String(codigo) ? { ...item, fixada } : item
  );
}
